import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { RegionService } from '../../services/region.service';

export interface ProgressBarState {
  index: number;
  routePath?: string;
}

@Component({
  selector: 'bullet-progress-bar',
  templateUrl: './bullet-progress-bar.html',
})
export class BulletProgressBarComponent {
  @Input() index: number;

  positions: ProgressBarState[];

  constructor(private router: Router, public regionService: RegionService) {
    this.positions = [
      {
        index: 1,
        routePath: 'visual-challenges',
      },
      {
        index: 2,
        routePath: 'age',
      },
      {
        index: 3,
        routePath: 'environment',
      },
      {
        index: 4,
        routePath: 'devices',
      },
      {
        index: 5,
        routePath: 'issues-experienced',
      },
      {
        index: 6,
        routePath: 'visual-behaviour',
      },
    ];
  }

  goToFlag(position: ProgressBarState): void {
    console.log(this.index, position.index);
    if (position.routePath && this.index > position.index) {
      this.router.navigate([position.routePath]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/bullet-progress-bar/bullet-progress-bar.component.ts